import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import HomePage from "@/pages/HomePage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ShopAllPage from "@/pages/ShopAllPage";
import CollectionPage from "@/pages/CollectionPage";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-cream" data-testid="app-root">
          <Navbar />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop/:section" element={<ShopAllPage />} />
              <Route path="/collection/:handle" element={<CollectionPage />} />
              <Route path="/product/:handle" element={<ProductDetailPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: { background: "#FAF8F4", color: "#3D2645", border: "1px solid rgba(61,38,69,0.1)" },
            }}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
